function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Icon Design - Merged"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.955 12.293A.5.5 0 0023.5 12H22A10 10 0 004.929 4.929a.5.5 0 00.707.707 9 9 0 0115.352 6.839.496.496 0 00.137.37.502.502 0 00.362.155h.911L20 15.74 17.602 13h.88a.5.5 0 00.498-.463 7.006 7.006 0 00-9.675-7 .5.5 0 00.384.924A6.002 6.002 0 0118 12h-1.5a.5.5 0 00-.376.83l3.5 4a.499.499 0 00.752 0l3.5-4a.5.5 0 00.08-.537zM18.364 18.364a9 9 0 01-15.352-6.839.496.496 0 00-.137-.37.502.502 0 00-.362-.155h-.911L4 8.26 6.398 11h-.88a.5.5 0 00-.498.463 7.006 7.006 0 009.675 7 .5.5 0 00-.384-.924A6.002 6.002 0 016 12h1.5a.5.5 0 00.376-.83l-3.5-4a.516.516 0 00-.752 0l-3.5 4A.5.5 0 00.5 12H2a10 10 0 0017.071 7.071.5.5 0 00-.707-.707z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})));